import { DistributionTitle, EquipmentItem, EventItem, NewsArticle, ProjectItem } from '../types';
import { CLIENT_MEDIA } from '../data/media';

export const INITIAL_PROJECTS: ProjectItem[] = [
  {
    id: 'proj-nayi-soch',
    title: 'NAYI SOCH (112)',
    genre: 'Short Film / International Women’s Day Special',
    director: 'Nikhil Vasantrao Shirbhate',
    synopsis: 'An impactful short film produced by Satish Tulshiramji Mohod in collaboration with Nagpur Police, featuring Mohana Ramteke. Highlighting safety, awareness, and social transformation.',
    posterUrl: CLIENT_MEDIA['nayi-soch'].desktop,
    trailerUrl: 'https://www.youtube.com/watch?v=orangecityproductions',
    releaseYear: 2024,
    status: 'PUBLISHED',
    featured: true,
    createdAt: '2024-03-06T00:00:00.000Z',
    updatedAt: '2026-02-15T00:00:00.000Z',
  },
  {
    id: 'proj-psycho',
    title: 'PSYCHO (SAMJO TO)',
    genre: 'Psychological Drama / Award-Winning Short Film',
    director: 'Nikhil V. Shirbhate',
    synopsis: 'Produced by Satish Mohod (Orange City Production), official selections at New Delhi Film Festival 2024, DPIFF Awards 2024, Lift-Off Global Network, and Mumba International Short Film Festival.',
    posterUrl: CLIENT_MEDIA['psycho'].desktop,
    releaseYear: 2024,
    status: 'PUBLISHED',
    featured: true,
    createdAt: '2024-01-10T00:00:00.000Z',
    updatedAt: '2026-02-18T00:00:00.000Z',
  },
  {
    id: 'proj-saheb',
    title: 'SAHEB VIKAS KARI',
    genre: 'Feature Film / Societal Drama',
    director: 'Nikhil V. Shirbhate',
    synopsis: 'Presented by Satish Mohod, Orange City Production. Written by Vaibhav Arjun Parab. Starring Kyra Agrawal, Satish Mohod, Shrutika Nikode, and Swapnil Bhongade. A sweeping cinematic narrative exploring infrastructure and community development.',
    posterUrl: CLIENT_MEDIA['saheb-vikaskari'].desktop,
    releaseYear: 2025,
    status: 'PUBLISHED',
    featured: true,
    createdAt: '2025-05-01T00:00:00.000Z',
    updatedAt: '2026-02-20T00:00:00.000Z',
  },
  {
    id: 'proj-father-son',
    title: 'FATHER & SON DUO LIVE IN CONCERT',
    genre: 'Musical Event / Entertainment Experience',
    director: 'Stargaze Live Production Unit',
    synopsis: 'Padma Bhushan Udit Narayan & Aditya Narayan live in concert at Indira Gandhi Indoor Stadium. Presented by Namaste Production & Iris Entertainment Events Pvt. Ltd.',
    posterUrl: CLIENT_MEDIA['father-son-duo'].desktop,
    releaseYear: 2023,
    status: 'PUBLISHED',
    featured: false,
    createdAt: '2023-09-30T00:00:00.000Z',
    updatedAt: '2026-02-10T00:00:00.000Z',
  },
];

export const INITIAL_EQUIPMENT: EquipmentItem[] = [
  {
    id: 'eq-1',
    name: 'ARRI Alexa Mini / SXT Package',
    category: 'Camera',
    specs: 'Industry standard digital cinema camera with ARRI color science and PL mount support.',
    dailyRate: 1500,
    availability: 'AVAILABLE',
    imageUrl: 'https://images.unsplash.com/photo-1512790182412-b19e6d62bc39?auto=format&fit=crop&w=800&q=80',
    status: 'PUBLISHED',
    updatedAt: '2026-02-10T00:00:00.000Z',
  },
  {
    id: 'eq-2',
    name: 'Sony Venice 1 & FX6 Cine Rig',
    category: 'Camera',
    specs: 'Full-frame dual ISO cinema sensor with high speed recording capabilities and custom anamorphic mount.',
    dailyRate: 1750,
    availability: 'AVAILABLE',
    imageUrl: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=800&q=80',
    status: 'PUBLISHED',
    updatedAt: '2026-02-12T00:00:00.000Z',
  },
  {
    id: 'eq-3',
    name: 'Ultra Prime & Sigma Prime Glass Set',
    category: 'Lens',
    specs: 'High-resolution prime lenses engineered for pristine sharpness, minimal breathing, and cinematic bokeh.',
    dailyRate: 1200,
    availability: 'AVAILABLE',
    imageUrl: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=800&q=80',
    status: 'PUBLISHED',
    updatedAt: '2026-02-14T00:00:00.000Z',
  },
  {
    id: 'eq-4',
    name: 'Optimo Zoom & Alura Zoom Rig',
    category: 'Lens',
    specs: 'Versatile cinematic zoom lenses with constant aperture and robust mechanical build for studio and handheld.',
    dailyRate: 950,
    availability: 'AVAILABLE',
    imageUrl: 'https://images.unsplash.com/photo-1520390138845-fd2d229dd553?auto=format&fit=crop&w=800&q=80',
    status: 'PUBLISHED',
    updatedAt: '2026-02-05T00:00:00.000Z',
  },
  {
    id: 'eq-5',
    name: 'Wireless Video & Follow Focus System',
    category: 'Accessories',
    specs: 'Teradek Bolt 4K zero-delay wireless transmission kit and Tilta Nucleus-M 3-channel wireless lens control.',
    dailyRate: 450,
    availability: 'AVAILABLE',
    imageUrl: 'https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80',
    status: 'PUBLISHED',
    updatedAt: '2026-02-08T00:00:00.000Z',
  },
  {
    id: 'eq-6',
    name: 'Matte Box & Optical Cinema ND Filtration',
    category: 'Accessories',
    specs: 'ARRI LMB 4x5 clip-on modular matte box with full-spectrum Firecrest Ultra IRND 0.3 - 2.1 glass filters.',
    dailyRate: 280,
    availability: 'AVAILABLE',
    imageUrl: 'https://images.unsplash.com/photo-1502920917128-1aa500764cbd?auto=format&fit=crop&w=800&q=80',
    status: 'PUBLISHED',
    updatedAt: '2026-02-09T00:00:00.000Z',
  },
  {
    id: 'eq-7',
    name: 'Master Cinematographer (DOP) & Camera Unit',
    category: 'DOP Requirement',
    specs: 'Veteran Director of Photography with lighting gaffer, focus puller, and digital imaging technician (DIT).',
    dailyRate: 2500,
    availability: 'AVAILABLE',
    imageUrl: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?auto=format&fit=crop&w=800&q=80',
    status: 'PUBLISHED',
    updatedAt: '2026-02-15T00:00:00.000Z',
  },
  {
    id: 'eq-8',
    name: 'Steadicam & Trinity Stabilizer Operator',
    category: 'DOP Requirement',
    specs: 'Certified ARRI Trinity and Steadicam M-2 operator for complex one-take tracking and dynamic sequences.',
    dailyRate: 1800,
    availability: 'AVAILABLE',
    imageUrl: 'https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=800&q=80',
    status: 'PUBLISHED',
    updatedAt: '2026-02-16T00:00:00.000Z',
  },
];

export const INITIAL_EVENTS: EventItem[] = [
  {
    id: 'evt-father-son',
    title: 'FATHER & SON DUO LIVE IN CONCERT',
    category: 'Premiere',
    location: 'Indira Gandhi Indoor Stadium',
    eventDate: '2023-09-30',
    description: 'Padma Bhushan Udit Narayan & Aditya Narayan live in concert. Presented by Namaste Production & Iris Entertainment Events Pvt. Ltd.',
    imageUrl: CLIENT_MEDIA['father-son-duo'].desktop,
    status: 'PUBLISHED',
    updatedAt: '2026-02-18T00:00:00.000Z',
  },
  {
    id: 'evt-premiere',
    title: 'NAYI SOCH WORLD SCREENING & AWARDS GALA',
    category: 'Premiere',
    location: 'Pune & Nagpur, Maharashtra',
    eventDate: '2024-03-06',
    description: 'Special theatrical screening of Nayi Soch (112) in collaboration with Nagpur Police and Orange City Productions.',
    imageUrl: CLIENT_MEDIA['nayi-soch'].desktop,
    status: 'PUBLISHED',
    updatedAt: '2026-02-01T00:00:00.000Z',
  },
];

export const INITIAL_DISTRIBUTION: DistributionTitle[] = [
  {
    id: 'dist-1',
    title: 'NAYI SOCH (112)',
    type: 'Film',
    territories: ['India', 'Global Digital Streaming'],
    rightsAvailable: ['YouTube', 'Digital OTT', 'Institutional Screening'],
    synopsis: 'Social impact short film available for digital streaming and public awareness broadcasting.',
    posterUrl: CLIENT_MEDIA['nayi-soch'].desktop,
    status: 'PUBLISHED',
    updatedAt: '2026-02-15T00:00:00.000Z',
  },
  {
    id: 'dist-2',
    title: 'PSYCHO (SAMJO TO)',
    type: 'Film',
    territories: ['Worldwide Festival Circuit', 'OTT Platforms'],
    rightsAvailable: ['SVOD', 'Theatrical Festival Rights'],
    synopsis: 'Critically acclaimed psychological short film distributed across global film festivals and OTT networks.',
    posterUrl: CLIENT_MEDIA['psycho'].desktop,
    status: 'PUBLISHED',
    updatedAt: '2026-01-20T00:00:00.000Z',
  },
  {
    id: 'dist-3',
    title: 'SAHEB VIKAS KARI',
    type: 'Film',
    territories: ['India', 'Global Digital Streaming'],
    rightsAvailable: ['Theatrical Rights', 'Digital OTT', 'Satellite'],
    synopsis: 'Compelling political-social drama feature presented by Satish Mohod (Orange City Production).',
    posterUrl: CLIENT_MEDIA['saheb-vikaskari'].desktop,
    status: 'PUBLISHED',
    updatedAt: '2026-02-28T00:00:00.000Z',
  },
];

export const INITIAL_NEWS: NewsArticle[] = [
  {
    id: 'news-1',
    title: 'Stargaze Media Expands Pune & Mumbai Production Infrastructure',
    summary: 'Comprehensive upgrade to camera rental packages and post-production suites in Maharashtra.',
    content: 'Stargaze Media continues its expansion as a premier entertainment hub in Pune and Maharashtra, supporting independent creators and major studio features alike.',
    author: 'Editorial Desk',
    publishDate: '2026-02-15',
    category: 'Announcement',
    imageUrl: CLIENT_MEDIA['saheb-vikaskari'].desktop,
    status: 'PUBLISHED',
    updatedAt: '2026-02-15T00:00:00.000Z',
  },
  {
    id: 'news-2',
    title: 'Nayi Soch Receives Acclaimed Recognition for Social Impact',
    summary: 'Collaboration with Nagpur Police and Orange City Productions reaches millions of viewers.',
    content: 'The powerful short film Nayi Soch (112) directed by Nikhil Vasantrao Shirbhate achieves massive outreach across digital platforms.',
    author: 'Stargaze PR',
    publishDate: '2026-01-10',
    category: 'Awards',
    imageUrl: CLIENT_MEDIA['nayi-soch'].desktop,
    status: 'PUBLISHED',
    updatedAt: '2026-01-10T00:00:00.000Z',
  },
];

export const TEAM_MEMBERS = [
  { name: 'Sachin Kamble', role: 'Founder & Executive Producer', bio: 'Visionary leader directing Stargaze Media’s strategic slate and global studio operations.' },
  { name: 'Sandi Tikkas', role: 'Creative Head & Visual Director', bio: 'Directing overarching aesthetic vision, poster designs, and cinematic brand identities.' },
  { name: 'Prashant Sonone', role: 'Senior D.O.P. & Editor', bio: 'Master cinematographer and offline editor overseeing high-end camera rigs and color grading.' },
  { name: 'Vishal Dudeja', role: 'Production & Logistics Coordinator', bio: 'Managing physical production schedules, equipment deployments, and soundstage management.' },
  { name: 'Amrita Pandey', role: 'Executive Producer & Co-Productions', bio: 'Overseeing financial packaging, international co-productions, and strategic studio partnerships.' },
  { name: 'Ashwin Sonone', role: 'Post-Production Supervisor', bio: 'Managing 8K workflows, Dolby Atmos mixing pipelines, and final digital cinema packaging.' },
  { name: 'Bharat Kakde', role: 'Technical & Equipment Head', bio: 'Directing ARRI, Sony, and Cooke lens inventory maintenance and on-set technical assistance.' },
];

export const STUDIO_PARTNERS = [
  { name: 'Pandav Enterprises', role: 'Production Partner' },
  { name: 'Dawn Studio', role: 'Post Production Suite' },
  { name: 'UFO', role: 'Distribution Network' },
  { name: 'Pune Gripper / Stargaze', role: 'Cine Camera & Equipment Division' },
  { name: 'Out of the Box', role: 'Film Branding & Creative Design' },
  { name: 'Mungama Media', role: 'PR & Marketing Agency' },
];
